<template lang="pug">
div(v-if="isSuperAdmin")
    status-badge.mb-1(v-if="thirdPartyMenuDisabled" tone="critical")
        | {{ $t('tp_diff.order_menu_disabled') }}
</template>

<script>
import AuthMixin from '@/components/mixins/AuthMixin'
import StatusBadge from '@/components/elements/StatusBadge.vue'

export default {
    components: {
        StatusBadge,
    },
    mixins: [AuthMixin],
    props: {
        item: null,
    },
    computed: {
        thirdPartyMenuDisabled() {
            let result = false
            if (
                this.item.thirdPartyDifferences?.length &&
                this.item.status === 'new'
            ) {
                this.item.thirdPartyDifferences?.[0].diffs?.forEach((diff) => {
                    if (diff.key === 'menu_disabled' && diff.remote === true) {
                        result = true
                    }
                })
            }
            return result
        },
    },
}
</script>
